module.exports = {
	customMedia: {
		'--small': 'screen and (max-width: 600px)',
		'--medium': 'screen and (min-width: 601px) and (max-width: 1000px)',
		'--medium-down': 'screen and (max-width: 1000px)',
		'--large': 'screen and (min-width: 1001px) and (max-width: 1440px)',
		'--large-down': 'screen and (max-width: 1440px)',
		'--xlarge': 'screen and (min-width: 1441px)'
	},
	customProperties: {
		'--text': 'rgba(0, 0, 0, 0.9)',
		'--text-light': '#5a5a5a',
		'--text-lighter': '#aba7a7',
		'--blue': '#123f98',
		'--alt-blue': '#001b54',
		'--light-blue': '#3c5eb5',
		'--data-blue': '#1646a7',
		'--lighter-blue': '#e9eef2',
		'--highlight-red': '#fa6868',
		'--substantial-increase-red': '#ff9a9a',
		'--dark-gray': '#95979e',
		'--darker-gray': '#525252',
		'--gray': '#b0b0b0',
		'--normal-range-gray': '#e9eef2',
		'--light-gray': '#e1e1e1',
		'--lighter-gray': '#eeeeee',
		'--baseline-black': '#757679',
		'--uncertainty-yellow': 'rgba(255, 236, 110, 0.3)',
		'--no-data-yellow': '#fffae3',
		'--size-large': '22px',
		'--size-normal': '19px',
		'--size-small': '16px',
		'--size-smaller': '14px',
		'--size-tiny': '13px',
		'--size-h1': 'calc(42 / 19 * 1rem)',
		'--size-h2': 'calc(33 / 19 * 1rem)',
		'--size-h3': 'calc(26 / 19 * 1rem)',
		'--size-h4': 'calc(16 / 19 * 1rem)',
		'--size-h5': '14px',
		'--size-h6': 'calc(19 / 19 * 1rem)',
		'--max-width': '1290px',
		'--gutter': '44px',
		'--gutter-small': '20px',
		'--column': '12.5%',
		'--margin-top': 'calc(var(--gutter) * 4)',
		'--margin-top-small': 'calc(var(--gutter-small) * 4)'
	},
	customSelectors: {

	}
};
